import handleAddToBox from "../../src/js/components/addToBox";
import utils from "../../src/js/utils";

const downloads_box = {
    init() {
        document.querySelectorAll('.downloads_box').forEach(section => {
            this.handleSelectedRows(section);
			this.updateProductsQuantity(section);

            section.querySelector('#download-selected-files').addEventListener('click', () => {
                const documentRows = section.querySelectorAll('input[name="selected_documents"]:checked');

                const attachments = [];
				const productVariants = [];

                documentRows.forEach(documentRow => {
					if ( documentRow.parentElement.parentElement.classList.contains( 'document_row__name--variant' ) ) {
						const variants = productLine.getAttribute('value');

						productVariants.push(variants);
					}

                    const all_languages = section.querySelectorAll(`[name^="document-language-${documentRow.value}"]`);
                    all_languages.forEach(attachment => {
                        attachments.push(attachment.value);
                    });
                });

				if ( productVariants.length > 0 ) {
					let url = `${documentation_php.documents_endpoint}?selected_documents=${attachments.join(',')}`;

					if ( documentation_php.user_id ) {
						url += `&user_id=${ documentation_php.user_id }`
					}

					window.open(url);
				} else {
					window.open(`${documentation_php.documents_endpoint}?selected_documents=${attachments.join(',')}`);
				}
            });

            section.querySelector('#download-selected-variants').addEventListener('click', () => {
				const varianst = section.querySelectorAll('input[name="selected_variants"]:checked');
				const variantsData = this.prepareVariantsData(varianst);
				const url = this.prepareVariantsQuery(variantsData);

				window.open(url, '_blank').focus();

            });

			section.querySelectorAll('.single_download_variant').forEach(singleBtn => {
				singleBtn.addEventListener('click', () => {
					const variantsData = this.prepareVariantsData([singleBtn]);
					const url = this.prepareVariantsQuery(variantsData);

					window.open(url, '_blank').focus();
				})
			})

            section.querySelectorAll('.clear-selected-files--documents').forEach(clearButton => {
				clearButton.addEventListener('click', () => {
					const productLines = section.querySelectorAll('input[name="selected_documents"]:checked');
					const documents = [...productLines].map(productLine => productLine.value);

					handleAddToBox.removeFromBox(documents, 'boxed_documents');

					documents.forEach(document => {
						const parent = section.querySelector(`.document_row[data-id="${document}"]`);
						parent.remove();
					});

					this.updateNumberOfFiles(section);

					section.querySelector('.downloads_box__download--documents')?.classList.remove('active');

					if ( utils.getCookie('boxed_documents').length == 0 || utils.getCookie('boxed_documents')?.split(',').length === 0 ) {
						section.querySelector('.downloads_all_documents')?.classList.add('disabled');
					} else {
						section.querySelector('.downloads_all_documents')?.classList.remove('disabled');
					}

					if ( document.querySelectorAll('.document_row').length === 0 ) {
						document.querySelector('.downloads_box__header__button--small').classList.add('disabled');
					}
				})
			});

            section.querySelectorAll('.clear-selected-files--variants').forEach(clearButton => {
				clearButton.addEventListener('click', () => {
					const productVariants = document.querySelectorAll('.document_product_variant input:checked');

					productVariants.forEach( productVariant => {
						const parentProductVariants = productVariant.parentElement.parentElement.parentElement;
						const variants = parentProductVariants.getAttribute('data-id');

						handleAddToBox.removeFromBox(variants, 'product_variants');
						parentProductVariants.remove();
					})

					this.updateNumberOfFiles(section);

					section.querySelector('.downloads_box__download--variants')?.classList.remove('active');

					const productCookieVariants = JSON.parse( utils.getCookie('product_variants') );

					if (utils.getCookie('product_variants') == 0 || productCookieVariants?.length === 0) {
						section.querySelector('.downloads_box__header__buttons--variants')?.classList.add('disabled');
					} else {
						section.querySelector('.downloads_box__header__buttons--variants')?.classList.remove('disabled');
					}
				})
			});

            section.querySelector('.downloads_all_documents').addEventListener('click', () => {
                const attachments = [];

                const all_languages = section.querySelectorAll(`[name^="document-language"]`);
                all_languages.forEach(attachment => {
                    attachments.push(attachment.value);
                });

				window.open(`${documentation_php.documents_endpoint}?selected_documents=${attachments.join(',')}`);
            });

			section.querySelector('.download_all_variants').addEventListener('click', () => {
				const varianst = section.querySelectorAll('input[name="selected_variants"]');
				const variantsData = this.prepareVariantsData(varianst);
				const url = this.prepareVariantsQuery( variantsData );

				window.open(url, '_blank').focus();
			});

            section.querySelector('.downloads_box__header__button--small.downloads_box__header__button--documents').addEventListener('click', () => {
                const productLines = section.querySelectorAll('input[name="selected_documents"]');
                const documents = [...productLines].map(productLine => productLine.value);

                handleAddToBox.removeFromBox(documents, 'boxed_documents');

                documents.forEach(document => {
                    const parent = section.querySelector(`.document_row[data-id="${document}"]`);
                    parent?.remove();
                });

                this.updateNumberOfFiles(section);

                section.querySelector('.downloads_box__download--documents').classList.remove('active');

                section.querySelector('.downloads_box__header__buttons--documents')?.classList.add('disabled');

				const titleCount = section.querySelector('#title-count');
				if ( titleCount ) {
                	titleCount.classList.add('hidden');
				}
            });

            section.querySelector('.downloads_box__header__button--small.downloads_box__header__button--variants').addEventListener('click', () => {
				const productVariants = document.querySelectorAll('.document_product_variant');

				const variants = [...productVariants].map(productVariant => productVariant.getAttribute('data-id'));

                handleAddToBox.removeFromBox(variants, 'product_variants');

				productVariants.forEach( productVariant => {
					productVariant.remove();
				} )

                this.updateNumberOfFiles(section);

                section.querySelector('.downloads_box__download--variants').classList.remove('active');

                section.querySelector('.downloads_box__header__buttons--variants')?.classList.add('disabled');
            });

            section.querySelectorAll('.document_row__icons__single--delete').forEach(deleteBtn => {
                deleteBtn.addEventListener('click', (e) => {
                    const id = deleteBtn.getAttribute('data-id');

					if ( deleteBtn.classList.contains('document_row__icons__single--variants') ) {
						handleAddToBox.removeFromBox(id, 'product_variants');
					} else {
						handleAddToBox.removeFromBox([id], 'boxed_documents');
					}

                    section.querySelector('.document_row[data-id="' + id + '"]').remove();

                    this.updateNumberOfFiles(section);

                    document.querySelector('.downloads_box__download').classList.remove('active');
                });
            });

            utils.getCookie('boxed_documents')?.split(',').forEach(document => {
                if (document.split('-').length > 1) {
                    const checkbox = section.querySelector(`input[value="${document}"]:not(:checked)`);
                    if (checkbox) {
                        checkbox.click();
                        checkbox.checked = true;
                    }
                }
            });
        });
    },

	prepareVariantsData( variants ) {
		if ( variants.length === 0 ) return;

		const variantsData = {};

		variants.forEach(variant => {
			const parent = variant.closest('.document_product_variant');
			const quantityContainer = parent.querySelector('.document_row__quantity input');
			const variantId = parent.getAttribute('data-id');
			let quantity = quantityContainer.value * 1;

			if ( quantity === 0 || ! quantity ) {
				quantity = 1;
			}

			variantsData[variantId] = quantity;
		})

		return variantsData;
	},

	prepareVariantsQuery( variantsData ) {
		const params = new URLSearchParams();

		for (const [variantId, quantity] of Object.entries(variantsData)) {
			params.append('product_variants[]', variantId);
			params.append(`quantity[${variantId}]`, quantity);
		}

		if (documentation_php.user_id) {
			params.append('user_id', documentation_php.user_id);
		}

		const queryString = params.toString();

		const url = `${window.location.origin}/wp-json/viking/v1/multiplyvariants?${queryString}`;

		return url;
	},

    handleSelectedRows(section) {
        section.querySelectorAll('.document_row__name').forEach(row => {
            row.addEventListener('click', () => {
                const checkboxes_documents = section.querySelectorAll('.document_row__name--document input:checked');
                const checkboxes_variants = section.querySelectorAll('.document_row__name--variant input:checked');
                const download_documents_section = section.querySelector('.downloads_box__download--documents');
                const header_documents_buttons = section.querySelector('.downloads_all_documents');

				const download_section_variants = section.querySelector('.downloads_box__download--variants');
				const header_buttons_variants = section.querySelector('.downloads_box__header__buttons--variants');

				const count_documents = section.querySelectorAll('.downloads_box__download--documents .count');
				const count_variants = section.querySelectorAll('.downloads_box__download--variants .count');

				if ( row.classList.contains('document_row__name--document') ) {
					this.handleGlobalActions( count_documents, checkboxes_documents, download_documents_section, header_documents_buttons );
				} else {
					this.handleGlobalActions( count_variants, checkboxes_variants, download_section_variants, header_buttons_variants );
				}
            });
        });
    },

    updateNumberOfFiles(section) {
        const rows = section.querySelectorAll('.document_row:not(.document_product_variant)');

		const rowsVariants = section.querySelectorAll('.document_product_variant');

		const titleCount = section.querySelector('#title-count');
        if (!rows || rows.length === 0) {
            section.querySelector('#empty-results')?.classList.remove('hidden');
			if ( titleCount ) {
				titleCount.innerHTML = '';
			}
        } else {
			if ( titleCount ) {
				titleCount.innerHTML = '(' + rows.length + ')';
			}
        }

		if (!rowsVariants || rowsVariants.length === 0) {
            section.querySelector('#empty-variants-results')?.classList.remove('hidden');
		}
    },

	handleGlobalActions( count, checkboxes, download_section, header_buttons ) {
		count.forEach(count => count.innerHTML = '(' + checkboxes.length + ')');

		if (checkboxes.length > 0) {
			download_section.classList.add('active');
			header_buttons.classList.add('disabled');
		} else {
			download_section.classList.remove('active');
			header_buttons.classList.remove('disabled');
		}
	},

	updateProductsQuantity(section) {
		const quantities = section.querySelectorAll('.document_row__quantity input');

		quantities?.forEach( quantity => {
			quantity.addEventListener('focusout', () => {
				const parent = quantity.closest('.document_product_variant');
				const id = parent.getAttribute('data-id');
				const newValue = parseInt(quantity.value);

				const variantsCookie = utils.getCookie('product_variants');

				let variants = variantsCookie ? JSON.parse(variantsCookie) : [];

				const variantIndex = variants.findIndex(variant => variant.id === id);
				if (variantIndex !== -1) {
					variants[variantIndex].quantity = newValue;
				}

				utils.setCookie('product_variants', JSON.stringify(variants));
			})
		} )
	}

}

document.addEventListener('DOMContentLoaded', () => {
    downloads_box.init();
});
